<template>
  <div class="introduce-page">
    <img class="banner" src="@/assets/images/introduce/introduce-banner.png" alt="">
    <div class="main">
<!--      <div class="title">公司简介</div>-->
        <div class="content" id="content"></div>
    </div>

  </div>
</template>

<script>
export default {
    name: "introduce",
    data() {
        return {
            detail: {},
        }
    },
    created(){
        this.initIntroduction();
    },
    methods: {
        async initIntroduction()
        {
            let contents = await this.$getContents(this.$channels.introduction);
            console.log("introduction.contents", contents)

            this.detail.detail = contents[0].body.replaceAll("/upload/images", process.env.VUE_APP_BASE_API + "/upload/images");
            console.log("robotData", this.detail)

            await this.$wrapDiv(this.detail.detail);
        }

    }
}

</script>

<style scoped>
.introduce-page{
  padding-bottom: 89px;
}
.banner{
  width: 100%;
}
.title{
  height: 67px;
  font-size: 48px;
  font-weight: bold;
  color: #333333;
  line-height: 67px;
  margin-top: 100px;
  margin-bottom: 36px;
}
.main{
  padding: 0 48px;
}
.content{
  margin-bottom: 48px;
  font-size: 28px;
  font-weight: 400;
  color: #666666;
  line-height: 50px;
}
</style>
